<template>
  <div class="margin-bottom-15">
    <div class="d-flex flex-column align-items-end">
      <div class="">
        <el-button type="primary" @click="openForm"> Tạo nhóm </el-button>
      </div>
    </div>
    <el-dialog :visible.sync="isShowCreateGroupForm" width="70%">
      <div class="title_popup text-center">Tạo nhóm mới</div>

      <vue-dropzone
        ref="dropzoneCreate"
        id="dropzone"
        :options="dropzoneOptions"
        @vdropzone-file-added="onFileAdded"
        @vdropzone-removed-file="onFileRemove"
        @vdropzone-mounted="onDropzoneMounted"
      />

      <br />
      <el-form class="create-group-form" ref="formPlagiarism" label-width="160px" label-position="right">
        <el-form-item label="Tên nhóm">
          <el-input placeholder="Tên nhóm" name="name" v-model="createGroupForm.name"></el-input>
        </el-form-item>

        <el-form-item label="Mô tả">
          <el-input placeholder="Mô tả" name="description" v-model="createGroupForm.description"></el-input>
        </el-form-item>

       <el-form-item label="">
         <el-checkbox v-model="createGroupForm.isCheckInternet"> Kiểm tra tài liệu với nguồn Internet</el-checkbox>
       </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeForm">Hủy bỏ</el-button>
        <el-button type="primary" @click="onSubmitCreateGroup" :disabled="loading">Tạo nhóm</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import { apiCreateGroup } from '@/services/group_management_service'
import { maxFileUpload } from '@/constants/DoITConstant'
import FAIcon from '@/components/common/FAIcon.vue'

export default {
  name: 'TagCreate',
  components: {
    vueDropzone: vue2Dropzone,
    FAIcon,
  },
  props: ['listDroppedFiles'],
  data: function () {
    return {
      isShowCreateGroupForm: false,
      loading: false,
      createGroupForm: {
        name: '',
        description: '',
        isCheckInternet: false,
      },
      dropzoneOptions: {
        url: 'https://httpbin.org/post',
        autoProcessQueue: false,
        thumbnailWidth: 150,
        maxFilesize: 100,
        maxFiles: maxFileUpload.GroupCreate,
        addRemoveLinks: true,
        dictRemoveFile: 'Loại bỏ',
        dictInvalidFileType: 'Sai định dạng file',
        dictMaxFilesExceeded: '',
        dictDefaultMessage: "<i class='fa fa-cloud-upload'></i>Nén tất cả tài liệu vào 1 file .zip sau đó tải lên đây",
        acceptedFiles: '.zip',
      },
      fileInProcess: 0,
    }
  },
  methods: {
    async onSubmitCreateGroup() {
      const loading = this.$loading({
        lock: true,
        text: 'Đang tạo nhóm',
        spinner: 'el-icon-loading',
      })

      let fileUpload = this.$refs.dropzoneCreate.getAcceptedFiles()
      if (fileUpload.length <= 0) {
        this.$message({
          message: 'Chọn tài liệu cần thêm vào trong nhóm',
          type: 'error',
        })
        return
      }

      let response_data = await apiCreateGroup(fileUpload[0], this.createGroupForm)

      loading.close()

      if (response_data != null && response_data.status === 'SUCCESS') {
        this.$message({
          message: response_data.description,
          type: 'success',
        })
        this.$emit('success')
      } else {
        this.$message({
          message: 'Có lỗi xảy ra',
          type: 'error',
        })
      }

      this.isShowCreateGroupForm = false
      this.$refs.dropzoneCreate.removeAllFiles()
    },
    onDropzoneMounted() {
      this.manuallyAddFile()
    },
    onFileAdded(file) {
      this.fileInProcess += 1
      if (this.fileInProcess > maxFileUpload.GroupCreate) {
        this.$message({
          message: 'Số tài liệu đã vượt quá số lượng quy định (không quá 1)',
          type: 'error',
        })
        this.$refs.dropzoneCreate.removeFile(file)
      } else {
        if (this.$refs.dropzoneCreate.getAcceptedFiles().length === 0) {
          this.$data.createGroupForm.name === ''
        }
        if (this.$data.createGroupForm.name === '')
          this.$data.createGroupForm.name = file.name.split('.').slice(0, -1).join('.')
      }
    },
    onFileRemove(file) {
      this.fileInProcess -= 1
    },
    closeForm() {
      this.isShowCreateGroupForm = false
      this.$refs.dropzoneCreate.removeAllFiles()
      this.$data.createGroupForm.name = ''
      this.$data.createGroupForm.description = ''
      this.fileInProcess = 0
    },
    openForm() {
      this.isShowCreateGroupForm = true
    },
    manuallyAddFile() {
      if (this.$refs.dropzoneCreate) {
        for (let i = 0; i < this.listDroppedFiles.length; i++) {
          if (this.fileInProcess < maxFileUpload.GroupCreate) {
            let fileType = this.listDroppedFiles[i].name.split('.').slice(-1)[0]
            let isAccepted = fileType === 'doc' || fileType === 'docx' || fileType === 'pdf' || fileType === 'zip'
            this.listDroppedFiles[i].accepted = isAccepted
            this.$refs.dropzoneCreate.manuallyAddFile(this.listDroppedFiles[i], '', null, null, {
              dontSubstractMaxFiles: false,
              addToFiles: true,
            })
          }
        }
        this.$emit('removeAllFileInDroppedList')
      }
    },
  },
  watch: {
    listDroppedFiles: function () {
      if (this.listDroppedFiles.length > 0) {
        this.isShowCreateGroupForm = true
        if (this.$refs.dropzoneCreate) {
          this.manuallyAddFile()
        }
      }
    },
    isShowCreateGroupForm: function () {
      if (!this.isShowCreateGroupForm) {
        this.$refs.dropzoneCreate.removeAllFiles()
        this.fileInProcess = 0
      }
    },
  },
}
</script>
<style scoped>
.create-group-form {
  margin-top: 10px;
}
</style>
